import { PROFILE } from "@/data/profile";
import { Mail, Linkedin, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer
      id="contact"
      data-testid="section-contact"
      className="bg-navy text-paper"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <p className="eyebrow text-gold mb-6">Get in touch</p>
            <h2 className="font-serif text-4xl md:text-5xl leading-[1.05] tracking-tight mb-8">
              Let's build something durable.
            </h2>
            <p className="text-paper/70 text-base leading-relaxed max-w-md">
              Advising, board conversations, revenue-strategy engagements and
              collaborations on capital-efficient scale.
            </p>
          </div>

          <div className="md:col-span-4 md:col-start-6">
            <p className="eyebrow text-paper/50 mb-3">Direct</p>
            <a
              href={`mailto:${PROFILE.email}`}
              data-testid="link-email"
              className="group flex items-center gap-3 text-2xl font-serif hover:text-gold transition-colors mb-8"
            >
              <Mail className="w-5 h-5 text-gold" strokeWidth={1.5} />
              <span className="border-b border-paper/20 group-hover:border-gold pb-1">
                {PROFILE.email}
              </span>
            </a>
            <p className="eyebrow text-paper/50 mb-3">Network</p>
            <a
              href={PROFILE.linkedin}
              target="_blank"
              rel="noreferrer noopener"
              data-testid="link-linkedin"
              className="group flex items-center gap-3 text-lg font-serif hover:text-gold transition-colors"
            >
              <Linkedin className="w-5 h-5 text-gold" strokeWidth={1.5} />
              <span className="border-b border-paper/20 group-hover:border-gold pb-1">
                linkedin.com/in/nimimohan
              </span>
              <ArrowUpRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" />
            </a>
          </div>

          <div className="md:col-span-3 md:col-start-10">
            <p className="eyebrow text-paper/50 mb-3">Based</p>
            <p className="text-lg font-serif mb-6">{PROFILE.location}</p>
            <p className="eyebrow text-paper/50 mb-3">Phone</p>
            <p className="text-lg font-serif">{PROFILE.phone}</p>
          </div>
        </div>

        <div className="mt-24 pt-8 border-t border-paper/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-xs text-paper/50">
            © {new Date().getFullYear()} Nimisha Mohan Srivastava · All views
            are personal.
          </p>
          <a
            href="/admin/login"
            data-testid="link-admin"
            className="text-xs text-paper/40 hover:text-gold transition-colors eyebrow"
          >
            Editor →
          </a>
        </div>
      </div>
    </footer>
  );
}
